import type {
	NahledyudajuIsssVyuzitiVypisSeznamVyuzivaniIsssParams,
	RezaOpravneniDto,
} from '@gov-nx/api';
import { isssUsageQuery, useAxiosInstance, usePoQuery } from '@gov-nx/api';

export const useUsageIsss = (
	params: Omit<NahledyudajuIsssVyuzitiVypisSeznamVyuzivaniIsssParams, 'start'>,
	rezaKod: RezaOpravneniDto['kod'] | null
) => {
	const { axiosInstance } = useAxiosInstance();

	const query = usePoQuery(
		{
			// TODO: This is a hotfix solution. Proper fix will be done in https://jira.acld.cloud/browse/NAKITPO-6027
			queryKey: ['isss-usage', rezaKod, params],
			queryFn: async () => {
				const response = await isssUsageQuery(axiosInstance, {
					...params,
					start: 1,
				});

				return response.data;
			},
		},
		{
			doNotShowToastError: true,
		}
	);

	return query;
};
